var _defs, _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _g4, _g5, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7bfa192b2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.015625 193 L 188 193 L 188 295 L 2.015625 295 Z M 2.015625 193 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "679e59424f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187 194 L 373 194 L 373 296.230469 L 187 296.230469 Z M 187 194 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "507f301b36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94 194 L 281 194 L 281 296.230469 L 94 296.230469 Z M 94 194 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c9bc254f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94 194 L 173 194 L 173 296.230469 L 94 296.230469 Z M 94 194 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0834f78679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 203 196 L 281 196 L 281 296.230469 L 203 296.230469 Z M 203 196 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a90c",
    d: "M 145.789062 98.640625 C 145.753906 98.457031 145.714844 98.28125 145.671875 98.097656 C 141.488281 79.480469 126.898438 73.609375 108.671875 72.890625 C 95.492188 72.367188 79.65625 69.539062 67.34375 75.519531 C 61.601562 78.304688 56.960938 82.960938 53.121094 88.0625 C 37.035156 109.480469 34.390625 138.058594 35.460938 164.835938 C 36.535156 191.609375 40.683594 218.652344 35.84375 245.007812 C 73.914062 244.824219 111.976562 244.121094 150.027344 242.898438 C 150.027344 214.398438 150.027344 185.890625 150.027344 157.382812 C 150.027344 137.773438 150.042969 117.882812 145.789062 98.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bfa192b2b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#96ddf8",
    d: "M 163.523438 222.460938 L 114.152344 193.628906 L 75.15625 193.628906 L 26.394531 222.429688 C 11.378906 231.304688 2.457031 245.707031 2.472656 261.054688 L 2.507812 294.859375 L 187.691406 294.859375 L 187.691406 261.1875 C 187.691406 245.765625 178.667969 231.304688 163.523438 222.460938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eba691",
    d: "M 110.382812 164.695312 L 78.703125 164.695312 L 78.703125 193.835938 L 110.382812 193.835938 L 110.382812 164.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecb695",
    d: "M 106.941406 173.253906 L 82.210938 173.253906 C 65.890625 173.253906 52.539062 159.898438 52.539062 143.5625 L 52.539062 111.394531 C 52.539062 95.0625 65.890625 81.707031 82.210938 81.707031 L 106.941406 81.707031 C 123.261719 81.707031 136.613281 95.0625 136.613281 111.394531 L 136.613281 143.5625 C 136.613281 159.898438 123.261719 173.253906 106.941406 173.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a90c",
    d: "M 106.425781 79.898438 C 111.199219 90.601562 107.550781 103.519531 100.480469 112.859375 C 93.402344 122.195312 83.386719 128.757812 73.769531 135.445312 C 64.148438 142.128906 54.464844 149.398438 48.582031 159.535156 C 42.996094 139.316406 44.992188 117.089844 54.113281 98.191406 C 56.800781 92.625 60.222656 87.179688 65.300781 83.644531 C 71.175781 79.558594 78.570312 78.464844 85.683594 77.671875 C 91.917969 76.964844 98.160156 76.402344 104.414062 75.976562 C 110.320312 75.570312 116.484375 75.328125 121.890625 77.730469 C 131.191406 81.851562 135.597656 92.410156 138.585938 102.144531 C 143.585938 118.457031 147.074219 135.628906 144.878906 152.550781 C 137.273438 143.285156 129.671875 134.019531 122.066406 124.753906 C 114.480469 115.511719 106.523438 105.289062 106.265625 93.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#679e59424f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#96ddf8",
    d: "M 348.824219 223.796875 L 299.453125 194.964844 L 260.457031 194.964844 L 211.695312 223.765625 C 196.671875 232.636719 187.757812 247.042969 187.773438 262.394531 L 187.8125 296.199219 L 372.996094 296.199219 L 372.996094 262.523438 C 372.996094 247.101562 363.972656 232.644531 348.824219 223.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eba691",
    d: "M 295.6875 166.03125 L 264.003906 166.03125 L 264.003906 195.171875 L 295.6875 195.171875 L 295.6875 166.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecb695",
    d: "M 292.234375 174.589844 L 267.511719 174.589844 C 251.191406 174.589844 237.84375 161.234375 237.84375 144.902344 L 237.84375 112.734375 C 237.84375 96.402344 251.191406 83.042969 267.511719 83.042969 L 292.234375 83.042969 C 308.558594 83.042969 321.914062 96.402344 321.914062 112.734375 L 321.914062 144.902344 C 321.914062 161.234375 308.558594 174.589844 292.234375 174.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a04c37",
    d: "M 245.933594 123.609375 C 248.546875 120.175781 252.035156 116.730469 256.375 115.378906 C 262.125 113.585938 266.648438 116.445312 271.992188 118.15625 C 277.742188 119.992188 283.945312 119.789062 289.878906 119.105469 C 294.085938 118.617188 297.542969 115.730469 301.683594 115.097656 C 308.617188 114.042969 315.179688 118.808594 318.101562 124.847656 C 319.152344 127.015625 319.3125 129.265625 320.035156 131.5 C 320.460938 132.84375 321.914062 134.539062 321.914062 135.964844 C 321.914062 135.636719 321.914062 112.734375 321.914062 112.734375 C 321.914062 96.402344 308.558594 83.035156 292.234375 83.035156 L 267.511719 83.035156 C 251.191406 83.035156 237.835938 96.402344 237.835938 112.734375 L 237.835938 134.363281 C 241.175781 130.902344 244.523438 125.464844 245.933594 123.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#507f301b36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#96ddf8",
    d: "M 255.976562 223.796875 L 206.605469 194.964844 L 167.613281 194.964844 L 118.851562 223.765625 C 103.835938 232.636719 94.914062 247.042969 94.929688 262.394531 L 94.964844 296.199219 L 280.148438 296.199219 L 280.148438 262.523438 C 280.148438 247.101562 271.125 232.644531 255.976562 223.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c9bc254f3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21335f",
    d: "M 167.765625 194.964844 L 167.613281 194.964844 L 118.851562 223.765625 C 103.835938 232.636719 94.914062 247.042969 94.929688 262.394531 L 94.964844 296.199219 L 172.316406 296.199219 C 173.050781 262.363281 172.132812 228.515625 167.765625 194.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0834f78679)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21335f",
    d: "M 255.976562 223.796875 L 208.574219 196.121094 C 202.386719 229.058594 202.414062 262.636719 204.824219 296.199219 L 280.148438 296.199219 L 280.148438 262.523438 C 280.148438 247.101562 271.125 232.644531 255.976562 223.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eba691",
    d: "M 202.839844 166.03125 L 171.15625 166.03125 L 171.15625 195.171875 L 202.839844 195.171875 L 202.839844 166.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecb695",
    d: "M 199.390625 174.589844 L 174.660156 174.589844 C 158.34375 174.589844 144.988281 161.234375 144.988281 144.902344 L 144.988281 112.734375 C 144.988281 96.402344 158.34375 83.042969 174.660156 83.042969 L 199.390625 83.042969 C 215.710938 83.042969 229.066406 96.402344 229.066406 112.734375 L 229.066406 144.902344 C 229.066406 161.234375 215.710938 174.589844 199.390625 174.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#21335f",
    d: "M 207.570312 106.65625 C 207.664062 106.679688 207.765625 106.703125 207.863281 106.722656 C 217.21875 109.039062 221.410156 120.523438 230.160156 124.5625 C 231.203125 125.046875 232.328125 125.414062 233.472656 125.371094 C 244.699219 124.929688 238.628906 96.113281 235.683594 90.882812 C 231.59375 83.617188 224.648438 77.8125 216.410156 76.011719 C 213.554688 75.386719 210.574219 75.179688 207.863281 74.078125 C 202.472656 71.890625 199.007812 66.585938 194.035156 63.570312 C 185.636719 58.480469 174.519531 60.925781 166.171875 66.105469 C 157.832031 71.28125 151.222656 78.816406 143.410156 84.769531 C 135.597656 90.722656 125.589844 95.171875 116.097656 92.667969 C 118.988281 107.011719 133.132812 117.089844 147.609375 119.117188 C 162.089844 121.152344 176.707031 116.621094 190.058594 110.640625 C 195.625 108.148438 201.644531 105.328125 207.570312 106.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientes);
export default __webpack_public_path__ + "static/media/Clientes.b9956dd2356a0f2cf49919d76196a360.svg";
export { ForwardRef as ReactComponent };